import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import S from "react";
import { c as m } from "./index-DkZ16bcJ.mjs";
import { m as R } from "./tss-DN0acMKN.mjs";
import { M as k, d as O } from "./constants-CnFYFetN.mjs";
import { R as W } from "./rounded-box-CXWaE0gJ.mjs";
import { F as I } from "./flex-Cc3osQLf.mjs";
const w = 0, B = 2, E = "36px", G = "36px", _ = "75px", v = "none", y = R()(({ mode: l, palette: e, spacing: a, typography: t }, s) => {
  var n, i, c, x;
  const d = e.gray[700], f = e.gray[200], { backgroundColor: h, color: g, flex: u, height: p, iconColor: b, iconHeight: C, iconWidth: H, margin: N, padding: o } = s;
  return {
    root: {
      alignItems: "center",
      backgroundColor: h || f,
      borderRadius: a(1),
      color: g || d,
      display: "flex",
      flex: u || v,
      gap: "10px",
      height: p || _,
      margin: N || a(w),
      outline: l === k.Dye ? `1px solid ${O.main}` : void 0,
      padding: o || a(B)
    },
    value: {
      fontSize: (n = t.biggie) == null ? void 0 : n.fontSize,
      fontWeight: t.fontWeightBold,
      lineHeight: (i = t.biggie) == null ? void 0 : i.lineHeight
    },
    label: {
      fontSize: (c = t.small) == null ? void 0 : c.fontSize,
      lineHeight: (x = t.small) == null ? void 0 : x.lineHeight
    },
    icon: {
      fill: b || g || d,
      // Defaults to text color
      height: C || E,
      width: H || G
    },
    warning: {
      color: e.warning.main
    },
    info: {
      color: e.info.main
    },
    error: {
      color: e.error.main
    }
  };
}), P = ({ icon: l, prefix: e, value: a = "--", label: t, ...s }) => {
  const { backgroundColor: d, color: f, flex: h, height: g, iconColor: u, iconHeight: p, iconWidth: b, margin: C, padding: H, className: N, classes: o, labelData: n } = s, { classes: i } = y({
    backgroundColor: d,
    color: f,
    flex: h,
    height: g,
    iconColor: u,
    iconHeight: p,
    iconWidth: b,
    margin: C,
    padding: H
  }), c = !!(n != null && n.text), x = /* @__PURE__ */ r.jsxs(I, { alignItems: "flex-start", className: o == null ? void 0 : o.textWrapper, flexDirection: "column", width: "80%", children: [
    /* @__PURE__ */ r.jsxs("span", { className: m(i.value, o == null ? void 0 : o.value), children: [
      e,
      a
    ] }),
    /* @__PURE__ */ r.jsxs(I, { alignItems: "center", justifyContent: "space-between", width: c ? "100%" : "", children: [
      /* @__PURE__ */ r.jsx("span", { className: m(i.label, o == null ? void 0 : o.label), children: t }),
      c ? /* @__PURE__ */ r.jsx("span", { className: m(i.label, i[n.status], o == null ? void 0 : o.labelData), children: n == null ? void 0 : n.text }) : null
    ] })
  ] }, "text");
  l = S.cloneElement(l, { className: m(i.icon, o == null ? void 0 : o.icon), key: "icon", "aria-hidden": !0 });
  const j = [l, x];
  return /* @__PURE__ */ r.jsx(W, { className: m(i.root, o == null ? void 0 : o.root, N), "data-fabric-component": "SummaryBlock", ...s, children: j });
};
export {
  P as S
};
//# sourceMappingURL=summary-block-BKI5guqu.mjs.map
